import axios from "axios";
import { hostname } from "../../utils";

/** Fetch all API keys for the current user and company. */
export async function fetchApiKeys(companyId: string, getToken: Function): Promise<any[]> {
  const tok = await getToken();
  const res = await axios.get(`${hostname}/api_keys`, {
    params: { companyId },
    headers: { Authorization: `Bearer ${tok}` },
  });
  return res.data;
}

/** Create a new API key with the given name. Returns the key value. */
export async function createApiKey(companyId: string, name: string, getToken: Function): Promise<string> {
  const tok = await getToken();
  const res = await axios.put(
    `${hostname}/api_keys`,
    { companyId, name },
    { headers: { Authorization: `Bearer ${tok}` } }
  );
  return res.data.apiKey;
}

/** Delete an API key by name. */
export async function deleteApiKey(companyId: string, name: string, getToken: Function): Promise<void> {
  const tok = await getToken();
  await axios.delete(`${hostname}/api_keys`, {
    data: { companyId, name },
    headers: { Authorization: `Bearer ${tok}` },
  });
}

/** Get the value of an existing API key by name. */
export async function getApiKeyByName(companyId: string, name: string, getToken: Function): Promise<string> {
  const tok = await getToken();
  const res = await axios.get(`${hostname}/api_keys/${companyId}/${name}`, {
    headers: { Authorization: `Bearer ${tok}` },
  });
  return res.data.apiKey;
}